"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Composer = _interopRequireDefault(require("./Composer"));

var _Context = _interopRequireDefault(require("./Context"));

var _createNativeUtterance = _interopRequireDefault(require("./createNativeUtterance"));

var _migrateDeprecatedProps = _interopRequireDefault(require("./migrateDeprecatedProps"));

var _SayUtterance = _interopRequireDefault(require("./SayUtterance"));

var _excluded = ["ponyfill"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Say = function Say(props) {
  var _migrateDeprecatedPro = (0, _migrateDeprecatedProps["default"])(props, Say),
      lang = _migrateDeprecatedPro.lang,
      onBoundary = _migrateDeprecatedPro.onBoundary,
      onEnd = _migrateDeprecatedPro.onEnd,
      onError = _migrateDeprecatedPro.onError,
      onStart = _migrateDeprecatedPro.onStart,
      pitch = _migrateDeprecatedPro.pitch,
      rate = _migrateDeprecatedPro.rate,
      speak = _migrateDeprecatedPro.speak,
      text = _migrateDeprecatedPro.text,
      voice = _migrateDeprecatedPro.voice,
      volume = _migrateDeprecatedPro.volume;

  var _useContext = (0, _react.useContext)(_Context["default"]),
      ponyfill = _useContext.ponyfill;

  if (speak && !text) {
    console.warn('react-say: "speak" prop is being deprecated and renamed to "text".');
    speak, (0, _readOnlyError2["default"])("text");
  }

  var utterance = (0, _react.useMemo)(function () {
    return (0, _createNativeUtterance["default"])(ponyfill, {
      lang: lang,
      onBoundary: onBoundary,
      pitch: pitch,
      rate: rate,
      text: text,
      voice: voice,
      volume: volume
    });
  }, [lang, onBoundary, pitch, ponyfill, rate, text, voice, volume]);
  return (
    /*#__PURE__*/
    _react["default"].createElement(_SayUtterance["default"], {
      onEnd: onEnd,
      onError: onError,
      onStart: onStart,
      ponyfill: ponyfill,
      utterance: utterance
    })
  );
};

Say.defaultProps = {
  children: undefined,
  lang: undefined,
  onBoundary: undefined,
  onEnd: undefined,
  onError: undefined,
  onStart: undefined,
  pitch: undefined,
  rate: undefined,
  speak: undefined,
  voice: undefined,
  volume: undefined
};
Say.propTypes = {
  children: _propTypes["default"].any,
  lang: _propTypes["default"].string,
  onBoundary: _propTypes["default"].func,
  onEnd: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onStart: _propTypes["default"].func,
  pitch: _propTypes["default"].number,
  rate: _propTypes["default"].number,
  speak: _propTypes["default"].string,
  text: _propTypes["default"].string.isRequired,
  voice: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].func]),
  volume: _propTypes["default"].number
};

var SayWithContext = function SayWithContext(_ref) {
  var ponyfill = _ref.ponyfill,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return (
    /*#__PURE__*/
    _react["default"].createElement(_Composer["default"], {
      ponyfill: ponyfill
    },
    /*#__PURE__*/
    _react["default"].createElement(Say, props))
  );
};

SayWithContext.defaultProps = _objectSpread(_objectSpread({}, _SayUtterance["default"].defaultProps), {}, {
  ponyfill: undefined
});
SayWithContext.propTypes = _objectSpread(_objectSpread({}, _SayUtterance["default"].propTypes), {}, {
  ponyfill: _propTypes["default"].shape({
    speechSynthesis: _propTypes["default"].any.isRequired,
    SpeechSynthesisUtterance: _propTypes["default"].any.isRequired
  })
});
var _default = SayWithContext;
exports["default"] = _default;